import {
    Divider,
    FormControl,
    FormControlLabel,
    Grid,
    makeStyles,
    Radio,
    RadioGroup,
    Typography,
  } from "@material-ui/core";
  import React, { useState } from "react";
  import BackwardGenealogy from "./BackwardGenealogy";
  import FilterBox from "./FilterBox";
  import StyledButton from "../models/Button";
import ForwardGenealogyFilter1 from "./ForwardGenealogyFilter1";
import ForwardGenealogyTable from "./ForwardGenealogyTable";
  
  const useStyles = makeStyles((theme) => ({
    mgTp: { marginTop: "1.5rem" },
    search: {
      padding: "2px 16px",
      backgroundColor: "#e36e39",
      color: "white",
      textTransform: "none",
      borderRadius: "2rem",
      "&:hover": {
        backgroundColor: "black",
        color: "white",
        border: "1px solid black",
      },
    },
    searchFld: {
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
      },
    },
    flxEd: {
      justifyContent: "flex-end",
    },
    hgText: {
      fontWeight: 500,
      paddingRight: theme.spacing(1),
    },
    outlined: {
      padding: theme.spacing(1),
    },
  }));
  
  const recordsArray = [
    { recordTypeName: "Backward genealogy", recordTypeID: "backwardGenealogy" },
    { recordTypeName: "Forward genealogy", recordTypeID: "forwardGenealogy" },
  ];
  
  const GenealogyReport = () => {
    const classes = useStyles();
    const [reportType, setReportType] = useState("backwardGenealogy");
    const [resError, setResError] = useState(null);
    const [showTable, setShowTable] = useState(false);
    const [selectedCMO, setSelectedCMO] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedBatch, setSelectedBatch] = useState(null);

    const [selectedMaterial, setSelectedMaterial] = useState(null);
    const [selectedBatchRMPM, setSelectedBatchRMPM] = useState(null);

    // forwardGenealogy states
  
    const selectReportType = (event) => {
      setResError(null);
      setShowTable(false);
      setSelectedCMO(null);
      setSelectedProduct(null);
      setSelectedBatch(null);
      setReportType(event.target.value);
    };
  
    const handleSelectFilterChanges = (type, value) => {
      setResError(null);
      setShowTable(false);
      if (type === "cmo") {
        setSelectedCMO(value);
      } else if (type === "productCodeDiscription") {
        setSelectedProduct(value);
      } else if (type === "batchNumber") {
        setSelectedBatch(value);
      } else if (type === "materialCodeDiscription") {
        setSelectedMaterial(value);
      } else if (type === "rmpmBatchNumber") {
        setSelectedBatchRMPM(value);
      }
    };
  
    const handleSubmit = () => {
      //console.log(selectedCMO)
      //console.log(selectedMaterial)
    //console.log(selectedBatchRMPM)
      if (reportType === "backwardGenealogy") {
        if (!selectedCMO || !selectedProduct || !selectedBatch) {
          setResError("Please enter the required fields");
        } else {
          setShowTable(true);
        }
      } else if (reportType === "forwardGenealogy") {
        if (!selectedCMO || !selectedMaterial || !selectedBatchRMPM) {
          setResError("Please enter the required fields");
        } else {
          setShowTable(true);
        }
      }
    };
  
    return (
      <React.Fragment>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              variant="body2"
              style={{ fontSize: "1rem", fontWeight: 500 }}
            >
              Select Record Type:
            </Typography>
          </Grid>
  
          <Grid item xs={12} sm={12} lg={12} xl={12}>
            <FormControl component="fieldset">
              <RadioGroup
                aria-label="report-filter"
                name="recordTypeID"
                row
                value={reportType}
                onChange={selectReportType}
              >
                {recordsArray.map((record, index) => (
                  <FormControlLabel
                    value={record.recordTypeID}
                    control={<Radio color="primary" />}
                    label={record.recordTypeName}
                    key={index}
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
  
        <Divider />
        <Grid container alignItems="center">
          <Grid
            container
            justify="center"
            style={{
              padding: "1rem 0",
              display: resError === null ? "none" : "inherit",
            }}
          >
            <Grid item xs={12} sm={6} md={6}>
              <Typography
                variant="h6"
                style={{
                  border: "1px solid #FF0000",
                  backgroundColor: "#FFF0F0",
                  opacity: "1",
                  textAlign: "center",
                  padding: "0.8rem",
                  fontSize: "0.875rem",
                }}
              >
                {resError}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="body2"
              style={{
                fontSize: "1rem",
                fontWeight: 500,
                marginBottom: "1rem",
                paddingTop: "1rem",
              }}
            >
              {reportType === "backwardGenealogy"
                ? "Please enter the CMO name, product code / description and batch number to view the report:"
                : reportType === "forwardGenealogy"
                ? "Please enter the CMO name, plant ID, material code/description, and RM/PM AR number to view the report:"
                : "Enter Record Details:"}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid container direction="row" alignItems="center" spacing={2}>
              {reportType === "backwardGenealogy" ? (
                <Grid item xs={12} sm={8} md={8}>
                  <FilterBox handleSelectChange={handleSelectFilterChanges} />
                </Grid>
              ) : reportType === "forwardGenealogy" ? (
                <Grid item xs={12} sm={9} md={9}>
                    <ForwardGenealogyFilter1 handleSelectChange={handleSelectFilterChanges} />
                </Grid>
              ): null}
              <Grid item xs={6} sm={6} md={2}>
                <StyledButton
                  color="primary"
                  type="submit"
                  className={classes.search}
                  onClick={handleSubmit}
                  style={{ borderRadius: "2rem" }}
                >
                  View Report{" "}
                </StyledButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
  
        {reportType === "backwardGenealogy" && showTable && (
          <Grid container>
            <BackwardGenealogy
              cmoDetails={selectedCMO}
              productData={selectedProduct}
              batchDetails={selectedBatch}
            />
          </Grid>
        )}

{reportType === "forwardGenealogy" && showTable && (
          <Grid container>
            <ForwardGenealogyTable
              cmoDetails={selectedCMO}
              materialData={selectedMaterial}
              rmpmBatchDetails={selectedBatchRMPM}
            />
          </Grid>
        )}
      </React.Fragment>
    );
  };
  
  export default GenealogyReport;
  